import { Breakpoints } from '@mui/material';
import tokens from '@skodaflow/web-tokens/src/tokens.json';

export const flowBreakpoints: Partial<{ unit: string; step: number } & Breakpoints> = {
  values: {
    xs: 0,
    // Flow 'mobile' (0 - 719)
    sm: Number(tokens['flow-grid'].default[0].breakpoint),
    // Flow 'tablet' (720 - 1079)
    md: Number(tokens['flow-grid'].default[1].breakpoint),
    // Flow 'desktop' (1080 - 1439)
    lg: Number(tokens['flow-grid'].default[2].breakpoint),
    // Flow 'desktop XL' (1440+)
    xl: Number(tokens['flow-grid'].default[3].breakpoint),
  },
};
